// API Configuration for DiscountDays Admin Panel
// Admin Panel API URL: https://godiscountdays.com/api/admin
// API for mobile apps: https://godiscountdays.com/api/v1
// CORS is configured on the backend, so we can use HTTPS directly

const getAdminBaseUrl = () => {
  // If using proxy in development, use relative URL
  if (process.env.REACT_APP_USE_PROXY === 'true') {
    return '/api/admin';
  }
  // Use environment variable if set, otherwise use the API admin URL
  return process.env.REACT_APP_ADMIN_URL || 'https://godiscountdays.com/api/admin';
};

const getApiBaseUrl = () => {
  // API base URL for mobile app endpoints (like store ratings)
  if (process.env.REACT_APP_USE_PROXY === 'true') {
    return '/api';
  }
  return process.env.REACT_APP_API_URL || 'https://godiscountdays.com/api';
};

export const API_CONFIG = {
  BASE_URL: getApiBaseUrl(),
  ADMIN_BASE_URL: getAdminBaseUrl(),
};

// API Endpoints
export const API_ENDPOINTS = {
  // Authentication
  LOGIN: `${API_CONFIG.ADMIN_BASE_URL}/login`,
  VERIFY: `${API_CONFIG.ADMIN_BASE_URL}/verify`,
  
  // Dashboard
  STATS: `${API_CONFIG.ADMIN_BASE_URL}/stats`,
  ACTIVITIES: `${API_CONFIG.ADMIN_BASE_URL}/activities/recent`,
  
  // Users
  USERS: `${API_CONFIG.ADMIN_BASE_URL}/users`,
  
  // Vendors
  VENDORS: `${API_CONFIG.ADMIN_BASE_URL}/vendors`,
  VENDORS_PENDING: `${API_CONFIG.ADMIN_BASE_URL}/vendors?status=pending`,
  VENDOR_APPROVE: (id: string) => `${API_CONFIG.ADMIN_BASE_URL}/vendors/${id}/approve`,
  VENDOR_REJECT: (id: string) => `${API_CONFIG.ADMIN_BASE_URL}/vendors/${id}/reject`,
  STORE_RATING_SUMMARY: (storeId: string) => `${API_CONFIG.BASE_URL}/v1/stores/${storeId}/ratings/summary`,
  
  // Offers
  OFFERS: `${API_CONFIG.ADMIN_BASE_URL}/offers`,
  
  // Analytics
  ANALYTICS: (range: string) => `${API_CONFIG.ADMIN_BASE_URL}/analytics?range=${range}`,
};

// Helper function to get auth headers
export const getAuthHeaders = (): HeadersInit => {
  const token = localStorage.getItem('token');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
};

// Helper function to handle API requests
export const apiRequest = async (url: string, options: RequestInit = {}) => {
  try {
    const response = await fetch(url, {
      ...options,
      headers: {
        ...getAuthHeaders(),
        ...options.headers,
      },
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'API request failed');
    }
    
    return data;
  } catch (error) {
    console.error('API request error:', error);
    throw error;
  }
};
